import { jsx } from "react/jsx-runtime";
import react from "react";
import { Flex, Image } from "pcln-design-system";
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
function LogoImage() {
    return /*#__PURE__*/ jsx(Flex, {
        width: 32,
        height: 32,
        alignItems: "center",
        children: /*#__PURE__*/ jsx(Image, {
            src: TRAVEL_BOT_LOGO,
            width: 32,
            alt: "Penny chat avatar"
        })
    });
}
const TravelBotLogoImage = /*#__PURE__*/ react.memo(LogoImage);
export { TravelBotLogoImage };
